import { connect } from "react-redux";
import { dismiss } from "../actions/notification";
import NotificationList from "../components/Notification/NotificationList";

const mapStateToProps = state => {
  return {
    notifications: state.notifications
  };
};

const Notifications = connect(mapStateToProps, { dismiss })(NotificationList);

export default Notifications;
